module.exports = __webpack_public_path__ + "img/暂无数据.ef742dd6.png";